import type {UserData as AvatarUserData} from '../../UserAvatar';

import type {OrganizationUserData} from './types';

export function toAvatarUser(user: OrganizationUserData): AvatarUserData | undefined {
    if (!user) {
        return;
    }

    const avatarUser: AvatarUserData = {
        isFederationUser: Boolean(user.federation),
    };

    if (user.pictureData) {
        avatarUser.avatarData = user.pictureData;
    } else {
        avatarUser.avatar = user.picture;
    }

    return avatarUser;
}
